import Layout from "@/layout";
export default {
  path: "ShoppingMall",
  component: () => import('@/views/AppMain/index'),
  name: "ShoppingMall",
  hidden: false,
  alwaysShow: true,
  meta: {
    title: "商城管理",
    keepAlive: false,
    icon: '1020',
    activeIcon: '1019',
    // activeMenu: '/HeadOfficeManagement/BasicDataManage/BasicData'
  },
  children: [
    {
      hidden: false,
      path: "HomePageSettings",
      component: () => import("@/views/HeadOfficeManagement/ShoppingMall/MainPageSetting/MainPageSetting"),
      name: "HomePageSettings",
      meta: {
        title: "首页设置",
        // keepAlive: false,
      },
    },
    {
      hidden: false,
      path: "AdvertisingPlacement",
      component: () => import("@/views/HeadOfficeManagement/ShoppingMall/AdvertisingPlacement/AdvertisingPlacement"),
      name: "AdvertisingPlacement",
      meta: {
        title: "广告投放",
        // keepAlive: false,
      },
    },
    // {
    //     hidden: false,
    //     path: "UserUseAgreement",
    //     component: () => import("@/views/HeadOfficeManagement/ShoppingMall/UserUseAgreement"),
    //     name: "UserUseAgreement",
    //     meta: {
    //       title: "用户使用协议",
    //       // keepAlive: false,
    //     },
    //   },
      // {
      //   hidden: false,
      //   path: "UserPrivacyAgreement",
      //   component: () => import("@/views/HeadOfficeManagement/ShoppingMall/UserPrivacyAgreement"),
      //   name: "UserPrivacyAgreement",
      //   meta: {
      //     title: "用户隐私协议",
      //     // keepAlive: false,
      //   },
      // },
      {
        hidden: true,
        path: "afterSaleService",
        component: () => import("@/views/HeadOfficeManagement/ShoppingMall/afterSaleService"),
        name: "afterSaleService",
        meta: {
          title: "售后服务",
          // keepAlive: false,
        },
      },
  ]
};
